/** Matches sections appended by `combineDescription` when newlines were lost (e.g. HTML collapse). */
const INLINE_MARKER_SPLIT = /(?=\sPersons involved:\s)|(?=\sContributing:\s)|(?=\sWitnesses:\s)/;

/** Split combined incident description from create payload into display sections. */
export function parseIncidentNarrative(raw: string): {
  main: string;
  personsInvolved?: string;
  contributingFactors?: string;
  witnessStatements?: string;
} {
  const trimmed = raw.trim();
  const paragraphs = trimmed
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean);

  let segments: string[];
  if (paragraphs.length > 1) {
    segments = paragraphs;
  } else {
    const single = paragraphs[0] ?? trimmed;
    const pieces = single
      .split(INLINE_MARKER_SPLIT)
      .map((s) => s.trim())
      .filter(Boolean);
    segments = pieces.length > 1 ? pieces : [single];
  }

  const main = segments[0] ?? trimmed;
  let personsInvolved: string | undefined;
  let contributingFactors: string | undefined;
  let witnessStatements: string | undefined;
  for (let i = 1; i < segments.length; i++) {
    const b = segments[i]?.trim() ?? "";
    if (b.startsWith("Persons involved: "))
      personsInvolved = b.slice("Persons involved: ".length).trim();
    else if (b.startsWith("Contributing: "))
      contributingFactors = b.slice("Contributing: ".length).trim();
    else if (b.startsWith("Witnesses: ")) witnessStatements = b.slice("Witnesses: ".length).trim();
  }
  return { main, personsInvolved, contributingFactors, witnessStatements };
}
